import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment'; 
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Grid, Link, Paper, TableContainer, Table, TableBody, TableCell, TableHead, TableRow, Typography
} from '@mui/material';
import PageTitle from '../ui/PageTitle';

import ServerError from '../ui/ServerError';
import LoadingSpinner from '../ui/LoadingSpinner';
import AppLogo from '../ui/AppLogo';

const abEnvironment = new AbEnvironment();
const ResellerCommProgramViewQuery = graphql`
query ResellerCommProgramViewQuery($resellerPId: UUID!) {
  resellerProgramTByResellerPId(resellerPId: $resellerPId) {
    resellerPId
    resellerAccountId
    accountTByResellerAccountId {
      accountName
			appTsByAccountId {
        nodes {
          appId
          oemAppId
          appName
          description
          appLogo
          appSku
        }
      }
    }
    programType
    programName
    description
    notes
    qualificationPeriod
    autoPayout
    active
    resellerProgramLineTsByResellerPId(orderBy:REVENUE_MIN_ASC) {
      totalCount
      nodes {
        resellerPlId
        revenuePeriod
        revenueMin
        incentivePerc
      }
    }
    cpId
    cpTByCpId {
      cpAppTsByCpId {
        nodes {
          appTByAppId {
            appId
          }
        }
      }
    }

  }
}
 `;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    flex: {
      flex: 1,
    },
    paper: {
      padding: theme.spacing(3),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      maxWidth: 980,
      marginTop: 16
    },
    tblHead: {
      backgroundColor: '#f1f1f1'
    }
  });
  
class ResellerCommProgramView extends Component {
  state = {
    apps: null
  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  goBack() {
    this.props.history.goBack();
  }

  render() {
    const { isAuthenticated, isAuthenticatedReseller, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    } else if (isAuthenticatedReseller()) {
      const params = new URLSearchParams(this.props.location.search);

      let resellerPId = params.get('resellerPId');
      let fp = params.get('fp');

      let backTo = "Partner programs";
      if (fp != null && fp !== '') {
        backTo = fp;
      }

      return (
        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={ResellerCommProgramViewQuery}
          variables={{resellerPId: resellerPId}}
          render={({error, props})=> {
            if (error) {
              logError(error.message);
              return (
                <ServerError/>
              );
            } else if (props) {
              let program = props.resellerProgramTByResellerPId;

              let resellerApps = program.accountTByResellerAccountId.appTsByAccountId;

              let programLines = program.resellerProgramLineTsByResellerPId.nodes;

              let apps = program.cpTByCpId.cpAppTsByCpId.nodes;

              return (
                <Grid container spacing={3} direction="row" justifyContent="flex-start">
                  <Grid item xs={12}>
                    <PageTitle title="Vendor partner program" showBackButton={true} name={backTo} noMargin={true} history={this.props.history}/>
                  </Grid>
                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      <Grid container spacing={2} direction="row" justifyContent="space-between">
                        <Grid item xs={12}>
                          <Grid container spacing={0} direction="column" justifyContent="flex-start">
                            <Grid item>
                              <Typography variant="h6">{program.programName}</Typography>
                            </Grid>
                            <Grid item>
                              <Typography variant="body2">{program.description}</Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        {/* 
                        <Grid item xs={12}>
                          <Typography variant="h6" style={AppBindStyles.sectionTitleFirst}>{program.programName}</Typography>
                        </Grid>
                        <Grid item xs={12} >
                          <TextField 
                            id="program-name" label="Commission program name"
                            value={program.programName}
                            InputProps={{ readOnly: true, disableUnderline: true }} 
                          />
                        </Grid>
                        <Grid item  xs={12}>
                          <TextField 
                            id="description" label="Description"
                            value={program.description}
                            inputProps={{ maxLength: 2048 }}
                            fullWidth
                            multiline
                            InputProps={{ readOnly: true, disableUnderline: true }} 

                          />
                        </Grid>
                        */}                   

                        <Grid item xs={12}>
                          <Grid container spacing={0} direction="column" justifyContent="flex-start">
                            <Grid item xs={12}> 
                            {program.programType === 0 &&
                              <Typography variant="h6">                                                          
                                Instant rebate
                              </Typography>
                            }
                            {program.programType === 1 &&
                              <Typography variant="h6">                                                             
                                Monthly rebate
                              </Typography>       
                            }
                            {program.programType === 2 &&
                              <Typography variant="h6">          
                                Monthly credits
                              </Typography>
                            }
                            {program.programType === 3 &&
                              <Typography variant="h6">                           
                                Prepaid credits
                              </Typography>
                            }
                            {program.programType === 4 &&
                              <Typography variant="h6">                           
                                Referral
                              </Typography>
                            }
                            </Grid>
                            <Grid item xs={12}>
                            {program.programType === 0 &&
                              <Typography variant="body2">                            
                                Wholesale discounts on subscriptions purchased through AppBind are applied immediately on every charge.
                              </Typography>
                            }
                            {program.programType === 1 &&
                              <Typography variant="body2">                            
                                At the end of the month, a sales commission is calculated based on volume during the month, and paid out as a rebate.
                              </Typography>
                            }
                            {program.programType === 2 &&
                              <Typography variant="body2">                            
                              At the end of the month, a sales commission is calculated based on volume during the month, and paid out as credits that can be applied to future purchases.
                              </Typography>
                            }
                            {program.programType === 3 &&
                              <Typography variant="body2">                            
                                Purchase credits up front at a discount.
                              </Typography>
                            }
                            {program.programType === 4 &&
                              <Typography variant="body2">                            
                                At the end of the month, a sales commission is calculated based on volume imported from external system, and paid out as a rebate.
                              </Typography>
                            }
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12}>
                          <Grid container spacing={0} direction="column" justifyContent="flex-start">
                            <Grid item xs={12}> 
                              <Typography variant="h6">Commission incentives</Typography>
                            </Grid>
                            <Grid item xs={12}> 
                              {program.qualificationPeriod === 0 &&
                                <Typography variant="body2">
                                    Commissons are based on last month sales
                                </Typography>
                              }
                              {program.qualificationPeriod === 1 &&
                                <Typography variant="body2">
                                  Commissions are based on total cumulative sales
                                </Typography>
                              }
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12}>
                          <TableContainer>
                            <Table>
                              <TableHead className={classes.tblHead}>
                                <TableRow>
                                  <TableCell align="right">Minimum sales</TableCell>
                                  <TableCell align="right">Incentive percentage</TableCell>
                                  {/*<TableCell align="center">{deleteHeader}</TableCell>*/}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {
                                // this.state.programLines && this.state.programLines.map(line => {
                                programLines && programLines.map(line => {
                                  let revenue = line.revenueMin;
                                  let perc    = line.incentivePerc;

                                  let revenueFormatted = Number(revenue)
                                    .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                                  return(
                                    <TableRow key={line.resellerPlId}>
                                      <TableCell align="right">
                                        {revenueFormatted}
                                        
                                      </TableCell>
                                      <TableCell align="right">
                                        {perc}
                                        
                                      </TableCell>
                                      
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>

                  {apps &&
                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      <Grid container spacing={2} direction="row" justifyContent="space-between">
                        <Grid item xs={12}>
                          <Grid container spacing={0} direction="column" justifyContent="flex-start">
                            <Grid item>
                              <Typography variant="h6">Apps</Typography>
                            </Grid>
                            <Grid item>
                              <Typography variant="body2">Apps in this vendor program</Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <TableContainer>
                            <Table>
                              <TableHead className={classes.tblHead}>
                                <TableRow>
                                  <TableCell align="left">Application</TableCell>
                                  <TableCell align="left">Description</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {apps && apps.map(app => {
                                  //NOTE: this is very inefficient bringing in all the resellers apps to find the matching - need a better solution.        
                                  //find the reseller's appid that (oem app id matches vendors)
                                  let i = 0;
                                  let resellerApp = null;
                                  for (i = 0; i < resellerApps.nodes.length; i++) {
                                    resellerApp = resellerApps.nodes[i];
                                    if (resellerApp.oemAppId === app.appTByAppId.appId) {
                                      //found the match;
                                      break;
                                    }
                                  }


                                  let theUrl = "app?appId=" + resellerApp.appId;
                                  return(
                                    <TableRow key={resellerApp.appId}>
                                    <TableCell>
                                      <Grid container alignItems="center">
                                        <Grid item>
                                          <AppLogo logoPath={resellerApp.appLogo} appName={resellerApp.appName} imageHeight='24px' theStyle={{marginRight: '8px'}}/>
                                        </Grid>
                                        <Grid item >
                                          <Link component="button" 
                                                variant="body2"
                                                onClick={this.goTo.bind(this, theUrl)}>
                                            {resellerApp.appName}
                                          </Link>
                                          {resellerApp.appSku != null && resellerApp.appSku !== '' && resellerApp.appSku !== resellerApp.appName &&
                                            <Typography variant="body2" >{resellerApp.appSku}</Typography>
                                          }
                                        </Grid>
                                      </Grid>
                                    </TableCell>
                                    <TableCell align="left">{resellerApp.description}</TableCell>
                                    
                                  </TableRow>

                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>}
                </Grid>
              );
            }
            return <LoadingSpinner />
          }}
        />
      )
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }
}

ResellerCommProgramView.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(ResellerCommProgramView);
